module.exports = __webpack_public_path__ + "static/standalone/img/date-invoice.4dd45478.svg";